export default __webpack_public_path__ + "static/pexels-mart-production-8459032_-b77dceb97c37b22bfa6912a2f668f833.jpg";